export const EVALUATION_COMPLETE_TITLE = 'Complete evaluation '

export const COMPLETE_EVALUATION_SUBMIT_TEXT = 'Save evaluation'
